import { GraphTooltip } from "components/GraphTooltip";
import { StyledTag } from "styles/StyledTags";
import { colors } from "styles/variables";

const DISPLAY: Record<
  "active" | "eligible",
  { label: string; color: { bg: string; text: string }; tooltip?: string }
> = {
  active: {
    label: "Active",
    color: { bg: colors.success["00"], text: colors.success["60"] },
  },
  eligible: {
    label: "Eligible (PIM)",
    color: colors.tagColors.yellow,
    tooltip: "Not currently active — must be activated via PIM.",
  },
};

/** Distinguishes standing role grants from PIM-eligible (activate-on-demand) ones */
export const RoleAssignmentStatusTag: React.FC<{
  assignmentType: "active" | "eligible";
}> = ({ assignmentType }) => {
  const { label, color, tooltip } = DISPLAY[assignmentType];
  return (
    <GraphTooltip title={tooltip}>
      <StyledTag color={color} ellipsis={true}>
        {label}
      </StyledTag>
    </GraphTooltip>
  );
};
